import { render, staticRenderFns } from "./addOrder_02.vue?vue&type=template&id=663139ee&scoped=true"
import script from "./addOrder_02.vue?vue&type=script&lang=js"
export * from "./addOrder_02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663139ee",
  null
  
)

export default component.exports